import * as ActionTypes from "../Types/ActionTypes";

export const DocPickupRequest = (
  state = {
    isLoading: true,
    errMess: null,
    docPickupRequest: [],
    // productid: [],
    // productorder: [],
  },
  action
) => {
  switch (action.type) {
    case ActionTypes.FETCH_docPickupRequest:
      return {
        ...state,
        isLoading: false,
        errMess: null,
        docPickupRequest: action.payload,
      };

    // case ActionTypes.FETCH_PRODUCTORDER:
    //   return {
    //     ...state,
    //     isLoading: false,
    //     errMess: null,
    //     productorder: action.payload,
    //   };

    // case ActionTypes.FETCH_PRODUCTID:
    //   return {
    //     ...state,
    //     isLoading: false,
    //     errMess: null,
    //     productid: action.payload,
    //   };

    case ActionTypes.docPickupRequest_LOADING:
      return { ...state, isLoading: true, errMess: null, docPickupRequest: [] };

    case ActionTypes.docPickupRequest_FAILED:
      return {
        ...state,
        isLoading: false,
        errMess: action.payload,
        docPickupRequest: [],
      };

    default:
      return state;
  }
};
